// src/index.jsx
// *******************************************************************************
// IMPORTS
// *******************************************************************************

import React from 'react';
import { createRoot } from 'react-dom/client';
import { App as AntdApp } from 'antd';

import App from './App.jsx';

import 'antd/dist/reset.css';
import 'assets/less/index.less';
import { ReactProvider } from 'components/core/ReactContext';

// *******************************************************************************
// CONSTANTS
// *******************************************************************************

const container = document.getElementById('root');
const root = createRoot(container);

// *******************************************************************************
// APPLICATION RENDER
// *******************************************************************************

root.render(
  <React.StrictMode>
    <ReactProvider value={true}>
      <AntdApp>
        <App />
      </AntdApp>
    </ReactProvider>
  </React.StrictMode>
);

// *******************************************************************************
// SERVICE WORKER REGISTRATION (enables PWA install prompt)
// *******************************************************************************

if ('serviceWorker' in navigator) {
  if (import.meta.env.DEV) {
    // DEV: unregister any existing SW to prevent SSE duplication (SW intercepts EventSource requests)
    navigator.serviceWorker.getRegistrations().then(regs => {
      regs.forEach(r => r.unregister());
    });
  } else {
    // PROD: register SW for PWA install prompt + offline caching
    window.addEventListener('load', () => {
      navigator.serviceWorker.register('/sw.js').catch(() => {
        // SW registration failed — PWA install prompt won't be available
      });
    });
  }
}
